import { DOCUMENT } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { AuxiliarService } from '@appNeo/neoShared/services/auxiliar/auxiliar.service';

@Component({
  selector: 'neo-elemento-imagen-slide',
  templateUrl: './elemento-imagen-slide.component.html',
  styleUrls: ['./elemento-imagen-slide.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ElementoImagenSlideComponent implements OnInit {

  @Input() imagen;
  @Input() titulo;
  @Input() tamanoTitulo: string;
  @Input() texto;
  @Input() enlace;
  @Input() boton;
  @Output() clickElemento = new EventEmitter<boolean>();

  constructor(
    private auxiliar: AuxiliarService,
    private router: Router,
    @Inject(DOCUMENT) document: any
  ) { }

  ngOnInit(): void { }

  redireccion(enlace) {
    let pathInterna = this.auxiliar.extraerPathDeUrlInterna(enlace);
    if (pathInterna) {
      this.router.navigate([pathInterna]);
    } else {
      window.location.href = enlace;
    }
  }

}
